/**
 * Shared chrome for the marketing/auth surfaces (waitlist, invite, sign-in,
 * sign-up, etc). Wordmark + top nav + centered content card + footer.
 */

import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { Wordmark } from '../brand/Wordmark';

export interface AuthShellProps {
  /** Right-aligned nav links shown next to the wordmark. */
  topRight?: ReactNode;
  children: ReactNode;
}

export function AuthShell({ topRight, children }: AuthShellProps) {
  return (
    <div className="auth-page">
      <div className="auth-top">
        <Wordmark to="/" size={19} />
        <div className="nav-right">{topRight}</div>
      </div>
      <div className="auth-center">{children}</div>
      <div className="auth-foot">
        <span className="left">ELOQUOR · MMXXVI</span>
        <div>
          <Link to="https://raymondjxu.net/terms">Privacy</Link>
          <Link to="https://raymondjxu.net/">Contact</Link>
        </div>
      </div>
    </div>
  );
}
